export default __webpack_public_path__ + "static/media/tag-privatesale.210cff2e.svg";